// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--zXFHz","title":"_4f720283bf--title--E_kJP"};